import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import SuccessModal from "../SuccessModal";
import JobRequests from "./JobRequests";
import TabMenu from "../TabMenu";
import { postStoreRiderJobPickupOrDelivery } from "../../services/StoreRiderInfo/StoreRiderInfo";
import StatusFilterModal from "../StatusFilterModal";
import StoreMenu from "../StoreMenu";
import ButtonLink from "../../ButtonLink";
import { localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";

const { innerWidth: width, innerHeight: height } = window;

const DashboardDeliveryJob = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { orderFilterData, source } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const { storeData } = getUserData();

  const storeId = storeData.id;
  const jobType = "delivery";

  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const handleConfirmAndContinue = () => {
    setModalMenuVisible(true);
  };

  const [showStartDatePicker, setShowStartDatePicker] = useState(false);
  const [showEndDatePicker, setShowEndDatePicker] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [focusedField, setFocusedField] = useState("");
  const [isLoading, setIsLoading] = useState(false); // New state for loading indicator
  const [isGetJobButtonPressed, setIsGetJobButtonPressed] = useState(false);
  const [statusFilterModalVisible, setStatusFilterModalVisible] =
    useState(false);
  const [upDateSelectedStatus, setUpDateSelectedStatus] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState("ALL");

  const minimumDate = new Date();
  minimumDate.setMonth(minimumDate.getMonth() - 120);

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3); // Add 3 months to current date

  const [orderInfoData, setOrderInfoData] = useState([]);
  const [todayOrderData, setTodayOrderData] = useState([]);

  const fetchRiderJobDeliveryData = (data) => {
    postStoreRiderJobPickupOrDelivery(storeId, jobType, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setTodayOrderData(Res);
        }
      })
      .catch((err) => {
        console.error("Rider Job Error:", err);
      });
  };

  useEffect(() => {
    const data = {
      startDate: localeDateStartDate(new Date(new Date(orderFilterData.startDate))),
      endDate: localeDateEndDate(new Date(new Date(orderFilterData.endDate))),
      jobStatus: orderFilterData.statusIn,
    };
    fetchRiderJobDeliveryData(data);
  }, []);

  const callRequestApi = () => {
    const data = {
      startDate: localeDateStartDate(new Date(new Date(orderFilterData.startDate))),
      endDate: localeDateEndDate(new Date(new Date(orderFilterData.endDate))),
      jobStatus: orderFilterData.statusIn,
    };
    fetchRiderJobDeliveryData(data);
  };

  const handleFilterModal = () => {
    setStatusFilterModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  const receiveDataFromStatusFilterModal = (selectedStatus) => {
    // setSelectedStatus(selectedStatus);
    handleConfirmDelivery(selectedStatus);
  };

  const handleConfirmDelivery = (selectedStatus) => {
    // Create a new delivery request object
    setIsLoading(true);
    if (!isGetJobButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsGetJobButtonPressed(true);
      setTimeout(() => {
        setIsLoading(false);

        const data = {
          startDate: localeDateStartDate(new Date(new Date(orderFilterData.startDate))),
          endDate: localeDateEndDate(new Date(new Date(orderFilterData.endDate))),
          jobStatus:
            selectedStatus !== "ALL"
              ? selectedStatus
              : orderFilterData.statusIn,
        };
        fetchRiderJobDeliveryData(data);

        setIsGetJobButtonPressed(false);
        // Reset the form fields
      }, 1000); // Replace with actual async operation duration
    }
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Delivery Job
              </p>
            </div>
          </div>

          <div
            onClick={() => handleFilterModal("DELIVERED")}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: height < 600 ? 25 : 30 }}
            />
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={"Added"}
        text={"Your Amount is added successfully."}
      />
      <StatusFilterModal
        setStatusFilterModalVisible={setStatusFilterModalVisible}
        statusFilterModalVisible={statusFilterModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
        upDateSelectedStatus={upDateSelectedStatus}
        OrderStatus={[
          "DELIVERY_REQ",
          "ASSIGNED_TO_RIDER",
          "RESCHEDULE_BY_CUSTOMER",
          "RESCHEDULE_BY_RIDER",
          "OUT_FOR_DELIVERY",
        ]}
      />

      <JobRequests
        orderInfoData={todayOrderData}
        JobType={jobType}
        storeId={storeId}
        callRequestApi={callRequestApi}
      />

      {/* <TabMenu /> */}
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
    </div>
  );
};

export default DashboardDeliveryJob;
